'use client'

import { Contacts } from '@/screens/Contacts'

import { InfoPageLayout } from '@/shared/lib/layouts/InfoPageLayout'

const ContactsPageContent = () => {
	return (
		<>
			<InfoPageLayout>
				<Contacts />
			</InfoPageLayout>
		</>
	)
}

export const ContactsClient = () => {
	return <ContactsPageContent />
}
